import { Box, Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup, TextField } from '@mui/material'
import React, { useState } from 'react'
import BasicSelect from '../select/BasicSelect'
import { Mexx2DOConsole } from '../../utils/mexxTalkConsole'

export default function CustomOrganizationField({ value, organizationField, changeValue, stateName, label }) {

  const [text, setText] = useState(value ? value : "")
  const [radioItem, setRadioItem] = useState(value ? value : 0)
  const [selectItem, setSelectItem] = useState(value ? value : 0)
  const [checkboxItem, setCheckboxItem] = useState(value ? value : false)
  const [likertAnswers, setLikertAnswers] = useState({})
  const maxLength = organizationField.maxlength ? organizationField.maxlength : 255
  console.log(organizationField)
  console.log(maxLength)
  console.log('maxLength organization field')

  const handleChange = (fieldType, id, value, stateName) => {

    if (fieldType === 1)
      setText(value)
    else if (fieldType === 2)
      setRadioItem(value)
    else if (fieldType === 3)
      setCheckboxItem(value)
    else if (fieldType === 4)
      setSelectItem(value)

    changeValue(fieldType, id, value, stateName)
  }

  const buildLikertAggregate = (statements, answers) => statements
    .map(statement => {
      const raw = answers[statement.id]
      const ids = Array.isArray(raw) ? raw : (raw ? [raw] : [])
      if (ids.length === 0) return null
      const names = ids
        .map(optionId => {
          const option = (statement.options || []).find(item => Number(item.id) === Number(optionId))
          return option ? option.name : null
        })
        .filter(Boolean)
      if (names.length === 0) return null
      return `${statement.name}: ${names.join(', ')}`
    })
    .filter(Boolean)
    .join('; ')

  const emitLikertChange = (statements, nextAnswers) => {
    setLikertAnswers(nextAnswers)
    handleChange(organizationField.organizationfieldtype, organizationField.id, {
      answers: nextAnswers,
      aggregate: buildLikertAggregate(statements, nextAnswers),
    }, stateName)
  }

  switch (organizationField.organizationfieldtype)
  {
    case 1:
      return (<TextField
        name={`ofield-${organizationField.id}`}
        label={`${label && label.length > 0 ? label : organizationField.name}`}
        fullWidth
        value={text}
        onChange={(e) => handleChange(organizationField.organizationfieldtype, organizationField.id, e.target.value, stateName)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ maxLength }} />)
    case 2:
      return (<RadioGroup
        name={`ofield-${organizationField.id}`}
        value={radioItem}
        onChange={(e) => handleChange(organizationField.organizationfieldtype, organizationField.id, e.target.value, stateName)}>
        { organizationField.organizationfieldoptionsvalues && organizationField.organizationfieldoptionsvalues.map(item => {
          return <FormControlLabel key={item.id} value={item.id} control={<Radio size="small" />} label={item.name} />
        })}
        </RadioGroup>)
    case 3:
      return (<FormGroup>
        <FormControlLabel
          checked={checkboxItem}
          control={<Checkbox />}
          label={`${label && label.length > 0 ? label : organizationField.name}`}
          onChange={(e) => handleChange(organizationField.organizationfieldtype, organizationField.id, e.target.checked, stateName)} />
      </FormGroup>)
    case 4:
      let listOptions = organizationField.organizationfieldoptionsvalues && organizationField.organizationfieldoptionsvalues.map(item => {
        return { id: item.id, name: item.name }
      })

      return (<BasicSelect
        name={`ofield-${organizationField.id}`}
        label={`*${label && label.length > 0 ? label : organizationField.name}`}
        list={listOptions}
        value={selectItem}
        handleChange={(value) => handleChange(organizationField.organizationfieldtype, organizationField.id, value, stateName)} />)
    case 11: {
      const statements = organizationField.likertstatements || []
      const isCheckboxMode = Number(organizationField.likertselectionmode) === 2
      const columns = statements[0] && Array.isArray(statements[0].options) ? statements[0].options : []

      const headCellSx = {
        px: 1.5,
        py: 1.5,
        fontSize: 13,
        fontWeight: 600,
        color: '#666666',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        textAlign: 'center',
        wordBreak: 'break-word',
        bgcolor: 'rgba(63, 81, 180, 0.04)',
        borderBottom: '1px solid #e0e0e0',
      }
      const bodyCellSx = {
        px: 1.5,
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }
      const separator = { borderTop: '1px solid #e0e0e0' }

      return (
        <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', overflow: 'hidden' }}>
          <Box sx={{ overflowX: 'auto' }}>
            <Box
              sx={{
                minWidth: 220 + columns.length * 110,
                display: 'grid',
                gridTemplateColumns: `minmax(180px, 1.4fr) repeat(${columns.length}, minmax(90px, 1fr))`,
              }}>
              <Box sx={{ ...headCellSx, justifyContent: 'flex-start', textAlign: 'left' }} />
              {columns.map((col, ci) => (
                <Box key={`likert-col-${organizationField.id}-${ci}`} sx={headCellSx}>
                  {col.name}
                </Box>
              ))}
              {statements.map((statement, ri) => {
                const selected = likertAnswers[statement.id]
                const selectedIds = Array.isArray(selected) ? selected.map(Number) : (selected ? [Number(selected)] : [])
                const rowSep = ri > 0 ? separator : null
                return (
                  <React.Fragment key={statement.id}>
                    <Box
                      sx={{
                        ...bodyCellSx,
                        ...rowSep,
                        justifyContent: 'flex-start',
                        fontSize: 14,
                        fontWeight: 500,
                        wordBreak: 'break-word',
                      }}>
                      {statement.name}
                    </Box>
                    {columns.map((col, ci) => {
                      const opt = (statement.options || [])[ci] || col
                      const optId = Number(opt.id)
                      const checked = selectedIds.includes(optId)
                      return (
                        <Box key={`likert-cell-${statement.id}-${ci}`} sx={{ ...bodyCellSx, ...rowSep }}>
                          {isCheckboxMode ? (
                            <Checkbox
                              checked={checked}
                              onChange={() => {
                                const next = checked
                                  ? selectedIds.filter(x => x !== optId)
                                  : [...selectedIds, optId]
                                emitLikertChange(statements, { ...likertAnswers, [statement.id]: next })
                              }} />
                          ) : (
                            <Radio
                              name={`ofield-${organizationField.id}-${statement.id}`}
                              value={String(optId)}
                              checked={checked}
                              onChange={() => emitLikertChange(statements, { ...likertAnswers, [statement.id]: optId })} />
                          )}
                        </Box>
                      )
                    })}
                  </React.Fragment>
                )
              })}
            </Box>
          </Box>
        </Box>
      )
    }
    default:
      return (<div></div>)
  }
}
